import { Base } from '../base-component';
import './content-card-stack.component.scss';

export class ContentCardStack extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/content-card-stack/content-card-stack.component.ts